import { put, takeEvery } from 'redux-saga/effects';
import { getWithToken } from '../../../api/network';
import {
  appNotify,
  setGroupsAreLoading,
  fetchCustomShapesForCopy
} from '../../../store/actions';

export function* getCustomShapesForCopySaga() {
  yield takeEvery(fetchCustomShapesForCopy, function* ({ payload }) {
    try {
      const { groupId, callback } = payload;
      yield put(setGroupsAreLoading(true));

      const url = `/api/assumptions/getPossibleShapesForCopy/${groupId}`;
      const res = yield getWithToken(url);
      const data = yield res.json();

      callback && callback(data);

      yield put(setGroupsAreLoading(false));
    } catch (error) {
      yield put(
        appNotify(`Failed to fetch shapes for copy: ${error.message}`, 'error')
      );
      yield put(setGroupsAreLoading(false));
    }
  });
}
